import { useMutation, useQuery, UseMutationOptions, UseQueryOptions } from '@tanstack/react-query'
import { TUseMutationOptions, TUseQueryOptions, TCustomUseQueryMeta } from 'core/query/type'
import {
  TGetLiveRoomGetLiveRoomParams,
  TGetLiveRoomGetLiveRoomResponse,
  getLiveRoomGetLiveRoom,
  TPostLiveRoomLiveRoomListByParamsParams,
  TPostLiveRoomLiveRoomListByParamsResponse,
  postLiveRoomLiveRoomListByParams,
  TPostLiveRoomCreateLiveRoomParams,
  TPostLiveRoomCreateLiveRoomResponse,
  postLiveRoomCreateLiveRoom,
  TPostLiveRoomLoudspeakerParams,
  TPostLiveRoomLoudspeakerResponse,
  postLiveRoomLoudspeaker,
  TPostLiveRoomOffLiveRoomParams,
  TPostLiveRoomOffLiveRoomResponse,
  postLiveRoomOffLiveRoom,
  TPostLiveRoomUpdateLiveRoomParams,
  TPostLiveRoomUpdateLiveRoomResponse,
  postLiveRoomUpdateLiveRoom,
  TPostLiveRoomAdminForbidParams,
  TPostLiveRoomAdminForbidResponse,
  postLiveRoomAdminForbid,
  TPostLiveRoomReportParams,
  TPostLiveRoomReportResponse,
  postLiveRoomReport,
  TGetLiveRoomGetLiveRoomListParams,
  TGetLiveRoomGetLiveRoomListResponse,
  getLiveRoomGetLiveRoomList,
  TPostLiveRoomTrackingFollowOrderParams,
  TPostLiveRoomTrackingFollowOrderResponse,
  postLiveRoomTrackingFollowOrder,
  TGetLiveRoomNoPageGetLiveRoomListParams,
  TGetLiveRoomNoPageGetLiveRoomListResponse,
  getLiveRoomNoPageGetLiveRoomList,
  TGetLiveRoomLivePlayingListParams,
  TGetLiveRoomLivePlayingListResponse,
  getLiveRoomLivePlayingList,
  TGetLiveBannersParams,
  TGetLiveBannersResponse,
  getLiveBanners,
  TGetLiveRoomCreateIMGroupParams,
  TGetLiveRoomCreateIMGroupResponse,
  getLiveRoomCreateIMGroup,
  TGetLiveRoomGetLoudspeakerParams,
  TGetLiveRoomGetLoudspeakerResponse,
  getLiveRoomGetLoudspeaker,
  TGetLiveRoomGetLatestLiveRoomParams,
  TGetLiveRoomGetLatestLiveRoomResponse,
  getLiveRoomGetLatestLiveRoom,
} from 'core/service/yapi/hk-web/LiveRoom/api'
// 直播间管理API
// 查询直播间详情
export const useGetLiveRoomGetLiveRoomQuery = (
  params?: TGetLiveRoomGetLiveRoomParams,
  options?: TUseQueryOptions<TGetLiveRoomGetLiveRoomResponse> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useQuery({
    ...options,
    queryKey: ['LiveRoom', 'LiveRoomGetLiveRoom', 'GET', ...Object.values(params || {})],
    queryFn: () => getLiveRoomGetLiveRoom(params, options?.meta?.requestOptions),
  })
}

// 查询直播间列表
export const usePostLiveRoomLiveRoomListByParamsMutation = (
  mutationOptions?: TUseMutationOptions<
    TPostLiveRoomLiveRoomListByParamsResponse,
    TPostLiveRoomLiveRoomListByParamsParams
  > & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['LiveRoom', 'LiveRoomLiveRoomListByParams', 'Post'],
    mutationFn: (params?: TPostLiveRoomLiveRoomListByParamsParams) =>
      postLiveRoomLiveRoomListByParams(params, mutationOptions?.meta?.requestOptions),
  })
}

// 创建直播间
export const usePostLiveRoomCreateLiveRoomMutation = (
  mutationOptions?: TUseMutationOptions<TPostLiveRoomCreateLiveRoomResponse, TPostLiveRoomCreateLiveRoomParams> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['LiveRoom', 'LiveRoomCreateLiveRoom', 'Post'],
    mutationFn: (params?: TPostLiveRoomCreateLiveRoomParams) =>
      postLiveRoomCreateLiveRoom(params, mutationOptions?.meta?.requestOptions),
  })
}

// 大喇叭
export const usePostLiveRoomLoudspeakerMutation = (
  mutationOptions?: TUseMutationOptions<TPostLiveRoomLoudspeakerResponse, TPostLiveRoomLoudspeakerParams> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['LiveRoom', 'LiveRoomLoudspeaker', 'Post'],
    mutationFn: (params?: TPostLiveRoomLoudspeakerParams) =>
      postLiveRoomLoudspeaker(params, mutationOptions?.meta?.requestOptions),
  })
}

// 下架直播间
export const usePostLiveRoomOffLiveRoomMutation = (
  mutationOptions?: TUseMutationOptions<TPostLiveRoomOffLiveRoomResponse, TPostLiveRoomOffLiveRoomParams> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['LiveRoom', 'LiveRoomOffLiveRoom', 'Post'],
    mutationFn: (params?: TPostLiveRoomOffLiveRoomParams) =>
      postLiveRoomOffLiveRoom(params, mutationOptions?.meta?.requestOptions),
  })
}

// 更新直播间
export const usePostLiveRoomUpdateLiveRoomMutation = (
  mutationOptions?: TUseMutationOptions<TPostLiveRoomUpdateLiveRoomResponse, TPostLiveRoomUpdateLiveRoomParams> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['LiveRoom', 'LiveRoomUpdateLiveRoom', 'Post'],
    mutationFn: (params?: TPostLiveRoomUpdateLiveRoomParams) =>
      postLiveRoomUpdateLiveRoom(params, mutationOptions?.meta?.requestOptions),
  })
}

// 管理员禁言+封禁(踢人)
export const usePostLiveRoomAdminForbidMutation = (
  mutationOptions?: TUseMutationOptions<TPostLiveRoomAdminForbidResponse, TPostLiveRoomAdminForbidParams> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['LiveRoom', 'LiveRoomAdminForbid', 'Post'],
    mutationFn: (params?: TPostLiveRoomAdminForbidParams) =>
      postLiveRoomAdminForbid(params, mutationOptions?.meta?.requestOptions),
  })
}

// 举报
export const usePostLiveRoomReportMutation = (
  mutationOptions?: TUseMutationOptions<TPostLiveRoomReportResponse, TPostLiveRoomReportParams> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['LiveRoom', 'LiveRoomReport', 'Post'],
    mutationFn: (params?: TPostLiveRoomReportParams) =>
      postLiveRoomReport(params, mutationOptions?.meta?.requestOptions),
  })
}

// 查询直播间列表
export const useGetLiveRoomGetLiveRoomListQuery = (
  params?: TGetLiveRoomGetLiveRoomListParams,
  options?: TUseQueryOptions<TGetLiveRoomGetLiveRoomListResponse> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useQuery({
    ...options,
    queryKey: ['LiveRoom', 'LiveRoomGetLiveRoomList', 'GET', ...Object.values(params || {})],
    queryFn: () => getLiveRoomGetLiveRoomList(params, options?.meta?.requestOptions),
  })
}

// 埋点-跟单点击
export const usePostLiveRoomTrackingFollowOrderMutation = (
  mutationOptions?: TUseMutationOptions<
    TPostLiveRoomTrackingFollowOrderResponse,
    TPostLiveRoomTrackingFollowOrderParams
  > & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['LiveRoom', 'LiveRoomTrackingFollowOrder', 'Post'],
    mutationFn: (params?: TPostLiveRoomTrackingFollowOrderParams) =>
      postLiveRoomTrackingFollowOrder(params, mutationOptions?.meta?.requestOptions),
  })
}

// 查询直播间列表无分页
export const useGetLiveRoomNoPageGetLiveRoomListQuery = (
  params?: TGetLiveRoomNoPageGetLiveRoomListParams,
  options?: TUseQueryOptions<TGetLiveRoomNoPageGetLiveRoomListResponse> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useQuery({
    ...options,
    queryKey: ['LiveRoom', 'LiveRoomNoPageGetLiveRoomList', 'GET', ...Object.values(params || {})],
    queryFn: () => getLiveRoomNoPageGetLiveRoomList(params, options?.meta?.requestOptions),
  })
}

// 查询待直播和直播中直播间列表
export const useGetLiveRoomLivePlayingListQuery = (
  params?: TGetLiveRoomLivePlayingListParams,
  options?: TUseQueryOptions<TGetLiveRoomLivePlayingListResponse> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useQuery({
    ...options,
    queryKey: ['LiveRoom', 'LiveRoomLivePlayingList', 'GET', ...Object.values(params || {})],
    queryFn: () => getLiveRoomLivePlayingList(params, options?.meta?.requestOptions),
  })
}

// 查询直播Banner列表
export const useGetLiveBannersQuery = (
  params?: TGetLiveBannersParams,
  options?: TUseQueryOptions<TGetLiveBannersResponse> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useQuery({
    ...options,
    queryKey: ['LiveRoom', 'LiveBanners', 'GET', ...Object.values(params || {})],
    queryFn: () => getLiveBanners(params, options?.meta?.requestOptions),
  })
}

// 直播间创建IM群组并返回GroupId
export const useGetLiveRoomCreateIMGroupQuery = (
  params?: TGetLiveRoomCreateIMGroupParams,
  options?: TUseQueryOptions<TGetLiveRoomCreateIMGroupResponse> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useQuery({
    ...options,
    queryKey: ['LiveRoom', 'LiveRoomCreateIMGroup', 'GET', ...Object.values(params || {})],
    queryFn: () => getLiveRoomCreateIMGroup(params, options?.meta?.requestOptions),
  })
}

// 获取大喇叭
export const useGetLiveRoomGetLoudspeakerQuery = (
  params?: TGetLiveRoomGetLoudspeakerParams,
  options?: TUseQueryOptions<TGetLiveRoomGetLoudspeakerResponse> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useQuery({
    ...options,
    queryKey: ['LiveRoom', 'LiveRoomGetLoudspeaker', 'GET', ...Object.values(params || {})],
    queryFn: () => getLiveRoomGetLoudspeaker(params, options?.meta?.requestOptions),
  })
}

// 查询当前主播最新直播间详情
export const useGetLiveRoomGetLatestLiveRoomQuery = (
  params?: TGetLiveRoomGetLatestLiveRoomParams,
  options?: TUseQueryOptions<TGetLiveRoomGetLatestLiveRoomResponse> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useQuery({
    ...options,
    queryKey: ['LiveRoom', 'LiveRoomGetLatestLiveRoom', 'GET', ...Object.values(params || {})],
    queryFn: () => getLiveRoomGetLatestLiveRoom(params, options?.meta?.requestOptions),
  })
}
